import { ReactElement } from "react";
import CoverImgContainer from "../cover-img-container/cover-img-container.comp";
import ImgListContainer from "../img-list-container/img-list-container.comp";
import "./home-main.comp.scss";

function HomeMainComp({ homeMainCompData }: HomeMainCompProps) {
  return (
    <div className="home-main-comp">
      <CoverImgContainer
        homeMainCompData={homeMainCompData}
      ></CoverImgContainer>
      <ImgListContainer homeMainCompData={homeMainCompData}></ImgListContainer>
    </div>
  );
}

export default HomeMainComp;

export interface HomeMainCompProps {
  homeMainCompData: {
    label: "profile" | "developer" | "graphic-designer";
    title: string;
    subtitle: string;
    img: string;
    button: {
      label: string;
      value: "as-dev" | "as-ig" | "more-dev" | "more-ig";
    }[];
    text?: string;
    imgList: {
      img: string;
      title: string;
      text: string;
      link?: string;
    }[];
    children?: ReactElement<any, any>;
  };
}
